import axios from 'axios'

const baseurl = import.meta.env.VITE_DOCUMENT_SERVICE_API_URL

const documentServiceApiClient = axios.create({
  baseURL: baseurl
})

export const postUploadImages = (data: FormData, contextToken: string): Promise<ImageReturnType[]> =>
  documentServiceApiClient
    .post<ImageReturnType[]>(`/images`, data, {
      headers: {
        Authorization: `Bearer ${contextToken}`
      }
    })
    .then((res) => res.data)

export const getImages = (contextToken: string): Promise<ImageReturnType[]> =>
  documentServiceApiClient
    .get<ImageReturnType[]>(`/images?reGenerateImageUrls=true`, {
      headers: {
        Authorization: `Bearer ${contextToken}`
      }
    })
    .then((res) => res.data)

export const deleteImageById = (imageId: string, contextToken: string): Promise<void> =>
  documentServiceApiClient
    .delete<void>(`/images/${imageId}`, {
      headers: {
        Authorization: `Bearer ${contextToken}`
      }
    })
    .then((res) => res.data)

export const postUploadDocuments = (data: FormData, contextToken: string): Promise<DocumentReturnType[]> =>
  documentServiceApiClient
    .post<DocumentReturnType[]>(`/documents`, data, {
      headers: {
        Authorization: `Bearer ${contextToken}`
      }
    })
    .then((res) => res.data)

export const getDocuments = (contextToken: string): Promise<DocumentReturnType[]> => {
  return documentServiceApiClient
    .get<DocumentReturnType[]>(`/documents?regenerateDocumentUrls=true`, {
      headers: {
        Authorization: `Bearer ${contextToken}`
      }
    })
    .then((res) => res.data)
}

export const deleteDocumentById = (documentId: string, contextToken: string): Promise<void> =>
  documentServiceApiClient
    .delete<void>(`/documents/${documentId}`, {
      headers: {
        Authorization: `Bearer ${contextToken}`
      }
    })
    .then((res) => res.data)

export const getPackage = (contextToken: string): Promise<string> =>
  documentServiceApiClient
    .post(
      `/packages/download`,
      { fileName: 'Liitteet', includeOnlyDocumentIds: [] },
      {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${contextToken}`
        }
      }
    )
    .then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.data]))
      return url
    })

export const getAllowedFileTypes = (contextToken: string): Promise<AllowedFileTypesType[]> => {
  return documentServiceApiClient
    .get<AllowedFileTypesType[]>(`/documents/allowed-file-types`, {
      headers: {
        Authorization: `Bearer ${contextToken}`
      }
    })
    .then((res) => res.data)
}
